import { OtherCareerVideoModel, RoadtripNationVideoModel } from '@/apiTypes/VideoTypes.ts';

export const VIDEOS_PER_PAGE_DESKTOP = 2;
export const DESKTOP_CAROUSEL_BASIS = `basis-1/${VIDEOS_PER_PAGE_DESKTOP}`;
export const VIDEOS_PER_PAGE_MOBILE = 1;
export const MOBILE_CAROUSEL_BASIS = 'basis-full';

export const convertToEmbedUrl = (
    youtubeUrl: string,
    options?: { autoplay?: boolean; captions?: boolean },
): string => {
    const videoIdMatch = youtubeUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/);

    if (videoIdMatch && videoIdMatch[1]) {
        const base = `https://www.youtube.com/embed/${videoIdMatch[1]}`;
        const params = new URLSearchParams();
        if (options?.autoplay) {
            params.set('autoplay', '1');
            // Browsers block unmuted autoplay so an autoplaying embed must start muted or not start.
            params.set('mute', '1');
        }
        if (options?.captions) params.set('cc_load_policy', '1');
        const query = params.toString();

        return query ? `${base}?${query}` : base;
    }

    return youtubeUrl;
};

export const getIsYouTubeUrl = (url: string): boolean => {
    return url.includes('youtube');
};

export const getVideoPageText = (
    videos: OtherCareerVideoModel[] | RoadtripNationVideoModel[],
    currentPage: number,
    videosPerPage: number,
    isDesktop: boolean,
) => {
    const totalVideos = videos.length;
    const videoIndex = currentPage * videosPerPage;
    const firstVideoNumber = videoIndex + 1;
    const remainingVideos = totalVideos - videoIndex;
    const isLastPage = remainingVideos <= videosPerPage;

    if (!isDesktop) {
        return `Video ${firstVideoNumber} / ${totalVideos}`;
    }

    if (isLastPage) {
        const firstVideo = Math.max(1, totalVideos - videosPerPage + 1);

        return `Videos ${firstVideo}-${totalVideos} / ${totalVideos}`;
    }

    const lastVideo = firstVideoNumber + videosPerPage - 1;

    return `Videos ${firstVideoNumber}-${lastVideo} / ${totalVideos}`;
};

export const getRoadtripNationNameAndTitleString = (video: RoadtripNationVideoModel) => {
    const name = video.fullName;
    const title = video.jobTitle;

    if (name && title) {
        return `${name}, ${title}`;
    }

    return name || title || '';
};

export const getRoadtripNationCompanyAndLocationString = (video: RoadtripNationVideoModel) => {
    const company = video.company;
    const location = video.interviewLocation;

    if (company && location) {
        return `${company} - ${location}`;
    }

    return company || location || '';
};

export const getRoadtripNationPartText = (video: RoadtripNationVideoModel): string | null => {
    if (video.partNumber && video.partTotal) {
        return `Part ${video.partNumber} / ${video.partTotal}`;
    }

    return null;
};
